import { render, staticRenderFns } from "./GlobalFooterOld.vue?vue&type=template&id=6d2e15f9&scoped=true"
import script from "./GlobalFooterOld.vue?vue&type=script&lang=js"
export * from "./GlobalFooterOld.vue?vue&type=script&lang=js"
import style0 from "./GlobalFooterOld.vue?vue&type=style&index=0&id=6d2e15f9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2e15f9",
  null
  
)

export default component.exports